"use client";

var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Check, ChevronDown, X } from "lucide-react";
import { useState, useCallback } from "react";
import { getProviderIcon } from "@llmgateway/shared/components";
import { Badge } from "./ui/badge.js";
import { Button } from "./ui/button.js";
import { Command, CommandEmpty, CommandInput, CommandItem, CommandList } from "./ui/command.js";
import { Popover, PopoverContent, PopoverTrigger } from "./ui/popover.js";
export function MultiProviderSelector(_a) {
  var providers = _a.providers,
    selectedProviders = _a.selectedProviders,
    onProvidersChange = _a.onProvidersChange,
    _b = _a.placeholder,
    placeholder = _b === void 0 ? "Select providers..." : _b;
  var _c = useState(false),
    open = _c[0],
    setOpen = _c[1];
  var handleProviderToggle = useCallback(function (providerId) {
    var isSelected = selectedProviders.includes(providerId);
    if (isSelected) {
      onProvidersChange(selectedProviders.filter(function (id) {
        return id !== providerId;
      }));
    } else {
      onProvidersChange(__spreadArray(__spreadArray([], selectedProviders, true), [providerId], false));
    }
  }, [selectedProviders, onProvidersChange]);
  var removeProvider = useCallback(function (providerId) {
    onProvidersChange(selectedProviders.filter(function (id) {
      return id !== providerId;
    }));
  }, [selectedProviders, onProvidersChange]);
  return _jsxs("div", {
    className: "space-y-2",
    children: [selectedProviders.length > 0 && _jsx("div", {
      className: "flex flex-wrap gap-1",
      children: selectedProviders.map(function (providerId) {
        var _a_0;
        var provider = providers.find(function (p) {
          return p.id === providerId;
        });
        var ProviderIcon = getProviderIcon(providerId);
        return _jsxs(Badge, {
          variant: "secondary",
          className: "flex items-center gap-1",
          children: [ProviderIcon && _jsx(ProviderIcon, {
            className: "h-3 w-3"
          }), (_a_0 = provider === null || provider === void 0 ? void 0 : provider.name) !== null && _a_0 !== void 0 ? _a_0 : providerId, _jsx(Button, {
            variant: "ghost",
            size: "sm",
            className: "h-3 w-3 p-0 hover:bg-transparent",
            onClick: function () {
              return removeProvider(providerId);
            },
            children: _jsx(X, {
              className: "h-2 w-2"
            })
          })]
        }, providerId);
      })
    }), _jsxs(Popover, {
      open: open,
      onOpenChange: setOpen,
      children: [_jsx(PopoverTrigger, {
        asChild: true,
        children: _jsxs(Button, {
          variant: "outline",
          role: "combobox",
          "aria-expanded": open,
          className: "w-full justify-between",
          children: [_jsx("span", {
            className: "text-left truncate",
            children: selectedProviders.length === 0 ? placeholder : "".concat(selectedProviders.length, " provider").concat(selectedProviders.length === 1 ? "" : "s", " selected")
          }), _jsx(ChevronDown, {
            className: "ml-2 h-4 w-4 shrink-0 opacity-50"
          })]
        })
      }), _jsx(PopoverContent, {
        className: "w-80 p-0 max-h-[400px]",
        align: "start",
        children: _jsxs(Command, {
          className: "flex flex-col",
          children: [_jsx(CommandInput, {
            placeholder: "Search providers..."
          }), _jsx("div", {
            className: "max-h-[300px] overflow-y-auto",
            children: _jsxs(CommandList, {
              children: [_jsx(CommandEmpty, {
                children: "No providers found."
              }), providers.map(function (provider_0) {
                var isSelected = selectedProviders.includes(provider_0.id);
                var ProviderIcon_0 = getProviderIcon(provider_0.id);
                return _jsxs(CommandItem, {
                  value: "".concat(provider_0.id, " ").concat(provider_0.name),
                  onSelect: function () {
                    return handleProviderToggle(provider_0.id);
                  },
                  className: "flex items-center justify-between py-3 cursor-pointer",
                  children: [_jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [ProviderIcon_0 && _jsx(ProviderIcon_0, {
                      className: "h-4 w-4"
                    }), _jsx("span", {
                      className: "font-medium",
                      children: provider_0.name
                    })]
                  }), _jsxs("div", {
                    className: "flex items-center gap-2",
                    children: [provider_0.color && _jsx("div", {
                      className: "w-3 h-3 rounded-full",
                      style: {
                        backgroundColor: provider_0.color
                      }
                    }), isSelected && _jsx(Check, {
                      className: "h-4 w-4 text-green-600"
                    })]
                  })]
                }, provider_0.id);
              })]
            })
          })]
        })
      })]
    })]
  });
}